module.exports = __webpack_public_path__ + "img/gala-logo.97a208b4.svg";